import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const Navbar = ({
  basePath = '/'
}: {
  basePath?: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const prefix = basePath === '/' ? '/' : basePath;
  const navItems = [{
    name: 'Features',
    href: `${prefix}#features`
  }, {
    name: 'Interfaces',
    href: `${prefix}#interfaces`
  }, {
    name: 'Integrations',
    href: `${prefix}#integrations`
  }, {
    name: 'Pricing',
    href: `${prefix}#pricing`
  }, {
    name: 'FAQ',
    href: `${prefix}#faq`
  }];
  return <header className="w-full bg-white z-40 shadow-sm border-b border-gray-100" data-id="element-380">
      <div className="container mx-auto px-4 py-3 sm:py-3.5 flex justify-between items-center" data-id="element-381">
        <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-382">
          <Link to="/" className="flex items-center gap-2" data-id="element-383">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2KuE4GiXagr4eVmupSGvce/fluid-form-logo.png" alt="FluidForm Logo" className="h-7 sm:h-8 w-auto" loading="eager" data-id="element-384" />
          </Link>
          <span className="inline-flex text-[9px] sm:text-[10px] md:text-[11px] font-medium text-gray-400 bg-gray-100 px-1.5 sm:px-2 py-0.5 rounded-full" data-id="element-385">
            by FluidWeb
          </span>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8" data-id="element-386">
          {navItems.map((item, index) => <a key={index} href={item.href} className="text-sm font-medium text-gray-600 hover:text-orange-600 transition-colors" data-id="element-387">
              {item.name}
            </a>)}
        </nav>

        <div className="hidden lg:flex items-center gap-3 xl:gap-4" data-id="element-388">
          <a href="https://accounts.fluid-form.ai/sign-in" onClick={() => window.gtag('event', 'signup_click', {
          source: 'nav_login'
        })} target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-gray-900 hover:text-orange-600 transition-colors" data-id="element-389">
            Login
          </a>
          <a href="https://accounts.fluid-form.ai/sign-up" onClick={() => window.gtag('event', 'signup_click', {
          source: 'nav_try_it'
        })} target="_blank" rel="noopener noreferrer" className="bg-orange-500 text-white px-4 xl:px-5 py-2 xl:py-2.5 rounded-lg text-sm font-semibold hover:bg-orange-600 transition-colors shadow-sm hover:shadow-md min-h-[44px] flex items-center" data-id="element-390">
            Try it now
          </a>
        </div>

        {/* Mobile menu button */}
        <button className="lg:hidden text-gray-700 p-2 min-h-[44px] min-w-[44px] flex items-center justify-center" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-391">
          {isOpen ? <XIcon size={24} data-id="element-392" /> : <MenuIcon size={24} data-id="element-393" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isOpen && <div className="lg:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-394">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-2" data-id="element-395">
            {navItems.map((item, index) => <a key={index} href={item.href} className="text-base font-medium text-gray-700 hover:text-orange-500 transition-colors py-3 min-h-[44px] flex items-center" onClick={() => setIsOpen(false)} data-id="element-396">
                {item.name}
              </a>)}
            <div className="pt-2 border-t border-gray-100 flex flex-col gap-3" data-id="element-397">
              <a href="https://accounts.fluid-form.ai/sign-in" target="_blank" rel="noopener noreferrer" className="text-center py-3 text-gray-900 font-medium border border-gray-200 rounded-lg hover:bg-gray-50 min-h-[44px] flex items-center justify-center" data-id="element-398">
                Login
              </a>
              <a href="https://accounts.fluid-form.ai/sign-up" target="_blank" rel="noopener noreferrer" className="text-center py-3 bg-orange-500 text-white font-medium rounded-lg hover:bg-orange-600 shadow-sm min-h-[44px] flex items-center justify-center" data-id="element-399">
                Try it now
              </a>
            </div>
          </div>
        </div>}
    </header>;
};
export default Navbar;